import { Controller } from '@hotwired/stimulus';
import { CHECKOUT_ADDRESS_FIELD_IDS } from '../lib/checkout_totals';

// cvr_checkbox_subscription_090926: reveals the consent checkbox and disables Pay Now for
// the states in Setting.subscription_terms_consent_states. statesValue carries codes and
// full names because the State field is free text.
export default class extends Controller {
  static targets = ['box', 'checkbox', 'copy', 'submit', 'status'];
  static values = { states: Array };

  connect() {
    this.stateInput = document.getElementById(CHECKOUT_ADDRESS_FIELD_IDS.state);

    this.boundUpdate = () => this.update();
    this.inputEvents = ['input', 'change', 'blur'];
    this.inputEvents.forEach((name) =>
      this.stateInput?.addEventListener(name, this.boundUpdate)
    );

    // Places autofills the state without firing input or change; this is its only signal.
    document.addEventListener('checkout-tax:request', this.boundUpdate);

    this.update();
  }

  disconnect() {
    this.inputEvents.forEach((name) =>
      this.stateInput?.removeEventListener(name, this.boundUpdate)
    );
    document.removeEventListener('checkout-tax:request', this.boundUpdate);
  }

  update() {
    const required = this.#consentRequired();

    this.boxTarget.hidden = !required;
    // The copy labels the box only while one is showing, or clicking the terms would toggle
    // an invisible checkbox. removeAttribute, not htmlFor = '': empty still matches [for].
    if (required) this.copyTarget.htmlFor = this.checkboxTarget.id;
    else this.copyTarget.removeAttribute('for');
    if (!required) this.checkboxTarget.checked = false;

    const blocked = this.#blocked();
    this.submitTarget.disabled = blocked;
    this.#announce(blocked);
  }

  // Only write on a change: a status region re-announces whenever its text is reassigned.
  #announce(blocked) {
    const message = blocked
      ? 'Accepting the subscription terms is required before you can pay.'
      : '';
    if (this.statusTarget.textContent !== message) {
      this.statusTarget.textContent = message;
    }
  }

  // showCheckoutValidationError re-enables #submit-payment unconditionally, and the wallet
  // path calls it too, so never trust the button's own state.
  guard(event) {
    if (!this.#blocked()) return;

    event.preventDefault();
    this.update();
  }

  #blocked() {
    return this.#consentRequired() && !this.checkboxTarget.checked;
  }

  #consentRequired() {
    const state = (this.stateInput?.value || '').trim().toUpperCase();
    if (!state) return false;

    return this.statesValue.includes(state);
  }
}
